import { useMediaQuery } from "@mui/material";
import BreadCrumbComp from "../../components/breadCrumb";
import HeaderBanner from "../../components/headerBanner";
import HexagonRequirement from "../../components/hexagonRequirement";
import { headerBannerType } from "../../constants/enums";
import "./styles.css";

const Requirements = () => {
  const isLargeScreen = useMediaQuery("(min-width:1150px)");

  return (
    <div className="App">
      <BreadCrumbComp />
      <div className="searchTitle riskAndOpportunityManagement-title">
        <h1>DASHBOARD REQUERIMIENTOS</h1>
      </div>
      <div class="table-container">
        <div className={`container-scroll ${isLargeScreen ? "j-center" : ""}`}>
          <div style={{ width: "920px" }}>
            <div
              className="IHContainer j-center"
              style={{
                gap: 20,
                margin: "0 0 0 -20px"
              }}
            >
               
              <HexagonRequirement
                backgroundImage={"images/hexagon/hex1.png"}
                type="blue"
                circlePosition="bottom-right"
                arrowPosition={"right"}
                arrow={"images/hexagon/flecha1.png"}
                circleIcon={"images/hexagon/calidad_blue.png"}
                title="Calidad del Producto"
                description="Suministrar productos que cumplan con los más altos estándares de calidad y las normativas vigentes."
                detailItems={[
                  "Registros sanitarios.",
                  "Fichas técnicas.",
                  "Hojas de seguridad.",
                  "BPM.",
                  "Certificado de capacidad de almacenamiento y acondicionamiento.",
                  "Inspección, vigilancia y control por Secretaría Distrital de Salud para establecimientos.",
                  "Resolución del Fondo Nacional de Estupefacientes."
                ]}
                internalMessageMargin="0px 0px 90px 0px"
                internalMessageMarginDetail="0px 0px -15px 0px"
              />
              <HexagonRequirement
                backgroundImage={"images/hexagon/hex2.png"}
                circlePosition="bottom-left"
                circleIcon={"images/hexagon/boxes.png"}
                arrowPosition={"bottom-right"}
                arrow={"images/hexagon/flecha2.png"}
                title="Cantidad Solicitada"
                description="Realizar los despachos conforme a las cantidades solicitadas por el cliente. En caso de presentarse faltantes, informar de manera oportuna la causa y la fecha estimada de entrega."
                type="yellow"
                detailItems={[
                  "P-GSC-003. Procedimiento trámites órdenes de compra.",
                  "Módulo pedidos pendientes.",
                  "Indicador de tiempos de entrega."
                ]}
                internalMessageMargin="0px 0px 60px 0"
                internalMessageMarginDetail="0px 0px 80px 0px"
              />
            </div>
            <div
              className="IHContainer j-center align-center"
              style={{
                gap: 45,
                margin: "-65px 0px"
              }}
            >
              <HexagonRequirement
                backgroundImage={"images/hexagon/hex3.png"}
                type="yellow"
                arrow={"images/hexagon/flecha6.png"}
                circlePosition="right"
                arrowPosition={"top-right"}
                circleIcon={"images/hexagon/tiempo_yellow.png"}
                title="Tiempo de Entrega"
                description="Cumplir con los tiempos de entrega establecidos: 24 horas hábiles para Bogotá, 48 horas hábiles para principales ciudades fuera de Bogotá y entre 72 a 144 horas hábiles para zonas de difícil acceso, o conforme a la programación de citas asignadas."
                detailItems={[
                  "P-GSC-003. Procedimiento trámites órdenes de compra.",
                  "Indicador de tiempos de entrega."
                ]}
                internalMessageMargin="0px 17px 28px -3px"
                internalMessageMarginDetail="0px 0px 90px -5px"
              />

            <div style={{ textAlign: "center" }}>
              <h3 style={{ marginBottom: "-10px" }}>Requerimientos</h3>
              <img
              src="images/seranestpharmalogo_Mesadetrabajo1.png"
              alt="Previsualización"
              style={{
              width: "215px",
              height: "160px",
              objectFit: "contain",
              borderRadius: "10px",
              marginTop: "0px"
                }}
              disabled
              />
              </div>
              <HexagonRequirement
                backgroundImage={"images/hexagon/hex4.png"}
                circlePosition="left"
                circleIcon={"images/hexagon/servici.png"}
                arrowPosition={"bottom-left"}
                arrow={"images/hexagon/flecha3.png"}
                title="Servicio Prestado"
                description="Brindar un servicio eficiente y oportuno, garantizando la atención de novedades, inquietudes, solicitudes y requerimientos documentales de los clientes."
                type="blue"
                detailItems={[
                  "Carpeta trazabilidad de cotizaciones.",
                  "Carpeta trazabilidad de actualización de clientes.",
                  "Carpeta trazabilidad de requerimientos documentales.",
                  "Módulo PQR (P-GSC-001 Procedimiento de Gestión de quejas, reclamos, sugerencias o felicitaciones)."
                ]}
                internalMessageMargin="0px 0px 60px 0px"
                internalMessageMarginDetail="0px 0px 25px 0px"
              />
            </div>
            <div
              className="IHContainer j-center"
              style={{
                gap: 20
              }}
            >
              <HexagonRequirement
                backgroundImage={"images/hexagon/hex5.png"}
                circlePosition="top-right"
                circleIcon={"images/hexagon/lugar.png"}
                arrowPosition={"top-left"}
                arrow={"images/hexagon/flecha5.png"}
                title="Lugar de Entrega"
                description="Garantizar la entrega exacta en el lugar acordado, según la sede, ciudad o ubicación establecida por el cliente."
                type="blue"
                detailItems={[
                  "P-GSC-003.",
                  "Procedimiento trámites órdenes de compra.",
                  "Indicador de tiempos de entrega.",
                  "R-GSF-016. Albarán de entregas."
                ]}
                internalMessageMargin="0px 0px 45px -1px"
                internalMessageMarginDetail="0px 0px 20px -1px"
              />

              <HexagonRequirement
                backgroundImage={"images/hexagon/hex6.png"}
                circlePosition="top-left"
                circleIcon={"images/hexagon/asilamie.png"}
                arrowPosition={"left"}
                arrow={"images/hexagon/flecha4.png"}
                title="Alistamiento de Productos"
                description="Asegurar un correcto almacenamiento y garantizar el embalaje adecuado para el transporte de medicamentos, dispositivos médicos y equipos biomédicos, cumpliendo las especificaciones técnicas exigidas por los fabricantes."
                type="yellow"
                detailItems={[
                  "P-GSF-003. Procedimiento de distribución de medicamentos.",
                  "P-GB-003. Procedimiento de alistamiento y despacho de dispositivos médicos y equipos biomédicos.",
                  "Medición y control de condiciones ambientales en tiempo real (Netux).",
                  "Inspección, vigilancia y control por Secretaría Distrital de Salud para vehículo propio."
                ]}
                internalMessageMargin="0 0px 0px 4px"
                internalMessageMarginDetail="0px 0px -30px 0px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Requirements;
